export const translationNavigation_sv_part2 = {
  pageSiteTitleHeading: "Sidspecifika sidrubrikar",
  pageSiteTitleHelp: "Hjälp för sidspecifika sidrubrikar",
  pageSiteTitleDescription:
    "Ändra titeln i chattfönstrets övre fält på utvalda sidor. Övriga sidor använder standardsidrubrik ovan.",
  pageSiteTitleText: "Sidrubrik för dessa sidor",
  pageSiteTitleNoDefault: "Ingen standardsidrubrik angiven",
  pageTitleHeading: "Sidspecifika chattrubrikar",
  pageTitleHelp: "Hjälp för sidspecifika chattrubrikar",
  pageTitleImmediate: "Sparas omedelbart",
  pageTitleSharedRule:
    "Den här regeln styr även en annan rubrik eller startar bilder. Ändras URL eller prioritet påverkas de; Ta bort rubrik bevarar dem.",
  pageTitleDescription:
    "Ändra rubriken inne i chatten på utvalda sidor. Övriga sidor använder standardrubriken ovan.",
  pageTitleMatching:
    "En sökväg som /delivery matchar alla URL:er som innehåller den texten (skiftlägeskänslig). För jokertecken, ange hela URL:en, t.ex. https://example.com/products/*.",
  pageTitleSaveHelp:
    "Lägg till rubrik och Spara rubrik träder i kraft omedelbart. Dessa regler kräver inte Publicera.",
  pageTitleEmpty: "Inga sidspecifika rubrikar ännu. Din standardrubrik gäller överallt.",
  pageTitleAddHeading: "Lägg till en sidspecifik rubrik",
  pageTitleUrl: "Sid-URL eller mönster",
  pageTitleText: "Chattrubrik för dessa sidor",
  pageTitleExample: "Leveranshjälp",
  pageTitlePriority: "Matchningsprioritet",
  pageTitlePriorityHelp:
    "Den första matchande sidregeln används. Lägre tal kontrolleras först; vid lika tal används den äldsta regeln. URL och prioritet gäller för alla rubrikar och bilder med den här regeln.",
  pageTitleOrder: "Prioritet (lägst först)",
  pageTitleSave: "Spara rubrik",
  pageTitleAdd: "Lägg till rubrik",
  pageTitleRemove: "Ta bort rubrik",
  pageTitleSaved: "Sparad",
  pageTitleSaving: "Sparar…",
  pageTitleTest: "Kontrollera en sid-URL",
  pageTitleTestHelp:
    "Ange en fullständig sid-URL för att se vilken sparad rubrik som gäller. Spara dina ändringar innan du kontrollerar.",
  pageTitleMatched: "Den här sidan använder en anpassad rubrik:",
  pageTitleDefault: "Den här sidan använder standardrubriken:",
  pageTitleNoDefault: "Ingen standardchattrubrik angiven",
  pageTitleMatchingRule: "Matchande sidregel",
  showLivechatAvailability: "Visa livechat-tillgänglighet i chattiteln",
  showLivechatAvailabilityDescription:
    "Visa en grön punkt när livechat är tillgänglig, baserat på chatbotens livechat-tillgänglighet och öppettider. Ingenting visas när livechat är offline.",
  widgetLeftSide: "Visa widget till vänster",
  widgetLeftSideDescription:
    "Placera startknappen och chattfönstret till vänster med popup-meddelanden som sträcker sig åt höger. Gäller startknappen på både dator och mobil.",
  launcherStyle: "Startknappens utseende",
  launcherStyleIcon: "Rund ikon",
  launcherStyleBar: "Startfält",
  launcherStyleDescription:
    "Startfältet visas i 5 sekunder på besökets första sida, visar popup-meddelanden i sitt textfält och är minimerat resten av tiden. Det öppnas igen när man pekar på det, utan att chatten öppnas.",
  launcherEdgeDistance: "Startknappens avstånd från kanten",
  mobileLauncherEdgeDistance: "Mobilstartknappens avstånd från kanten",
  mobileLauncherLeftEdge: "Kompakt startknapp i vänster kant",
  mobileLauncherLeftEdgeDescription:
    "Visa en 44 px kvadratisk startknapp halvvägs upp på vänster kant på mobil med din befintliga ikon. Åsidosätter mobilposition och storlek när den är aktiverad.",
  mobileLauncherLeftEdgeBarNotice: "Gäller inte när startfältet är valt.",
  userMessageColor: "Användarmeddelande",
  userMessageTextColor: "Användarmeddelande text",
  userMessageBorderColor: "Användarmeddelande kant",
  inputTextColor: "Inmatningsfält text",
  inputPlaceholderColor: "Inmatningsfält platshållare",
  inputBackgroundColor: "Inmatningsfält bakgrund",
  inputBorderColor: "Inmatningsfält kant",
  inputFieldHeight: "Inmatningsfält höjd (px)",
  inputFieldHeightDescription: "Höjden på inmatningsfältet.",
  sendButtonIconColor: "Skicka-knapp ikon",
  headerLogo: "Sidhuvud-logotyp (ladda upp fil)",
  messageIcon: "Avatar (ladda upp fil)",
  messageIconSize: "Avatarstorlek (px)",
  messageIconSizeDescription: "Avatarens storlek.",
  fontSize: "Textstorlek (px)",
  fontSizeDescription: "Textstorlek i chatten. Standard är 16. Tillåtet intervall: 10–24.",
  headerTitle: "Sidhuvudrubrik",
  headerSubtitle: "Sidhuvud underrubrik",
  formattedTextHint: "Använd Fet eller Länk för att formatera delar av texten.",
  formattedTextBold: "Fet",
  formattedTextLink: "Länk",
  formattedTextLinkPrompt: "Ange länk-URL",
  privacyPolicyUrl: "Integritetspolicy-URL",
  headerAlignment: "Sidhuvud justering",
  alignLeft: "Vänsterjustera",
  alignCenter: "Centrera",
  alignRight: "Högerjustera",
  siteTitle: "Sidtitel",
  initialMessage: "Initialt meddelande",
  buttonColor: "Knappbakgrund",
  discountPriceColor: "Rabatterat pris",
  surfaceThemeGroup: "Yta",
  headerThemeGroup: "Sidhuvud",
  messagesThemeGroup: "Meddelanden",
  inputThemeGroup: "Inmatning",
  productCardThemeGroup: "Produktkort",
  addToCartButtonIcon: "Lägg i kundvagn-knapp ikon",
  addToCartButtonIconDescription:
    "Ladda upp en anpassad ikon för lägg i kundvagn-knappen på produktkort. Lämna tomt för att använda standardikonen för kundvagn.",
  addToCartDisabledHint: "Aktivera lägg i kundvagn i admininställningarna för att anpassa ikonen.",
  moreColorSettings: "Fler färginställningar",
  popupMessage: "Popup-meddelande",
  publish: "Publicera",
  uploadLogo: "Ladda upp logotyp",
  uploadIcon: "Ladda upp ikon",
  selectChatbot: "Välj chatbot",
  editingChatbotId: "Redigerar chatbot-ID",
  textTooLongWarning: "Texten kan se dålig ut på mindre skärmar",
  borderRadius: "Kantradie",
  borderRadiusDescription:
    "Styr rundheten på chatbotens hörn (0.5 = skarp, 1.0 = normal, 2.0 = mycket rund)",
  zIndexButton: "Z-Index – Knapp (skiktning)",
  zIndexChatWindow: "Z-Index – Chattfönster (skiktning)",
  customChatButtonImage: "Anpassad chatknapp-bild (valfritt)",
  customChatButtonDescription:
    "Ladda upp en anpassad bild eller GIF för att ersätta standard-SVG-chattknappen. Lämna tomt för att använda standardknappen. Hela bilden kan klickas, beskär bort transparenta kanter.",
  mobileCustomizations: "Mobilanpassningar",
  mobileCustomizationsDescription:
    "Valfria åsidosättningar för mobila enheter. Om de inte är angivna används datorinställningarna.",
  mobileChatButtonImage: "Mobil chattknapp-bild",
  mobileChatButtonDescription:
    "Ladda upp en separat bild för mobilvisning. Lämna tomt för att använda datorknappen. Hela bilden kan klickas, beskär bort transparenta kanter.",
  adaptiveIconColor: "Adaptiv startknapp-färg",
  adaptiveIconColorHint:
    "Gäller endast chatt/startknappen. Ladda upp en enkel ikon för bästa kontrast på ljusa och mörka bakgrunder.",
  mobileButtonPositionBottom: "Mobilknapp position – Botten",
  mobileButtonPositionRight: "Mobilknapp position – Höger",
  buttonSize: "Knappstorlek (px)",
  buttonSizeDescription:
    "Storleken på chattknappen i pixlar, från 30 till 200. En anpassad bild behåller sina proportioner och detta är dess längsta sida. Standard: 74",
  chatbotWidth: "Chatbot-bredd",
  chatbotHeight: "Chatbot-höjd",
  chatbotSizeDescription: "Datorstorlek.",
  openAnimationEnabled: "Öppna chatbot med glidanimation",
  mobileButtonSize: "Mobilknapp-storlek (px)",
  mobileButtonSizeDescription:
    "Storleken på chattknappen på mobil i pixlar, från 30 till 200. En anpassad bild behåller sina proportioner och detta är dess längsta sida. Standard: 50",
  launcherSizeClampedNotice: "Chattknappen visas i {size} px.",
  removeButton: "Ta bort",
  resetToDefault: "Återställ till standard",
  clickSaveToPersist: "Klicka Spara för att behålla",
  saveReminder: "Ändringar sparas endast i databasen när du klickar på Spara-knappen ovan",
  showPopupOnMobile: "Visa popup på mobila enheter",
  showPopupOnMobileDescription:
    "Avmarkera för att inaktivera popup på mobil (visas fortfarande på dator)",
  livePreview: "Liveförhandsvisning",
  openPreviewInNewTab: "Öppna i ny flik",
  fullscreen: "Helskärm",
  exitFullscreen: "Avsluta helskärm",
  desktop: "Dator",
  mobile: "Mobil",
  chatbotActive: "Aktiv",
  chatbotDisabled: "Inaktiverad",
  disabledSince: "Inaktiverad sedan",
  disableChatbot: "Inaktivera chatbot",
  disableChatbotConfirmation:
    "Är du säker på att du vill inaktivera den här chatboten? Den kommer inte längre att vara synlig på din webbplats.",
  enableChatbot: "Aktivera chatbot",
  enableChatbotConfirmation:
    "Är du säker på att du vill aktivera den här chatboten? Den kommer att vara synlig igen på din webbplats för besökare.",
  cancel: "Avbryt",
  disable: "Inaktivera",
  enable: "Aktivera",
  developerChatbotVisibilityTitle: "Chatbot på din webbplats",
  developerChatbotVisibilitySectionDescription:
    "Slå på eller av den offentliga chatboten för besökare. Det här påverkar inte redigering eller förhandsvisning på chatbot-sidan.",
  developerChatbotVisibilityChatbotLabel: "Chatbot",
  developerDisableChatbotButton: "Inaktivera chatbot på webbplatsen",
  developerEnableChatbotButton: "Aktivera chatbot på webbplatsen",
  developerChatbotVisibilityAcknowledge:
    "Jag förstår att detta ändrar den aktiva webbplatsen för besökare.",
  developerChatbotVisibilityNoChatbots:
    "Inga chatbotar är kopplade till det här kontot. Chatbot-ID:n läses in när du loggar in.",
  developerChatbotVisibilityDisabledNotice:
    "Chatboten är inaktiverad på den offentliga webbplatsen.",
  developerChatbotVisibilityEnabledNotice:
    "Chatboten är nu aktiverad på den offentliga webbplatsen.",
  developerChatbotVisibilityStatusActive: "Aktiv på webbplatsen",
  developerChatbotVisibilityStatusDisabled: "Inaktiverad på webbplatsen",
  developerChatbotVisibilityLoadError: "Kunde inte läsa in chatbot-status.",
  developerChatbotVisibilityToggleError: "Kunde inte uppdatera chatbot-status.",
  popupDailyDesktop: "Dator: maximalt antal visningar per dag",
  popupTotalDesktop: "Dator: maximalt antal visningar totalt",
  popupDailyMobile: "Mobil: maximalt antal visningar per dag",
  popupTotalMobile: "Mobil: maximalt antal visningar totalt",
  popupEveryNthPage: "Visa på var N:te matchande sida",
  popupDismissDays: "Paus efter stängning (dagar)",
  popupFrequency: "Visningsfrekvens",
  popupUseDefault: "Använd botens standard",
  popupResetDefaults: "Återställ till botens standardvärden",
  popupFrequencyHelp:
    "Gränser gäller separat för varje bubbla i den här webbläsaren. Dagsgränser återställs vid midnatt, dansk tid. Matchande sidor räknas över dagar. Att stänga en bubbla pausar bara den bubblan; att öppna chatten pausar alla bubblor för idag. Sätt en visningsgräns till 0 för att inaktivera det layouten.",
  popupMaxDisplays: "Popup max visningar (dator och mobil)",
  popupMaxDisplaysDescription:
    "Maximalt antal visningar per popup i besökarens webbläsare, på dator och mobil. Sätt till 0 för att inaktivera popups. Standard: 2",
  chatbotWindowDimensions: "Chatbot-fönster dimensioner",
  chatbotWindowDimensionsDescription:
    "Styr hur chatbot-iframen storleksanpassas. Stöder CSS-värden som px, vw, vh, calc(), etc.",
  desktopWidth: "Datorbredd",
  desktopHeight: "Datorhöjd",
  mobileWidth: "Mobilbredd",
  mobileHeight: "Mobilhöjd",
  enlargedWidth: "Utvidgad bredd",
  enlargedHeight: "Utvidgad höjd",
  // Livechat Settings translations
  // Livechat Settings translations
  livechatSettingsTitle: "Livechat-inställningar",
  agentInformation: "Agentinformation",
  agentNameLabel: "Ditt agentnamn",
  profilePicture: "Profilbild",
};
